import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../redux/hooks';
import { storeAppAuth } from '../../redux/reducers/authSlice';
import useURLParamsForVerification from '../../hooks/useURLParams';
import { toastMessages } from '../../constants/errorMessages';
import { REDIRECTING } from '../../constants/common';
import { ROUTE_PATHS } from '../../constants/routePaths';
import { showToast } from '../../services/toast.service';

const InvitationToken = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useURLParamsForVerification({
    onSuccess: e => {
      navigate(ROUTE_PATHS.CREATE_PASSWORD);
      dispatch(storeAppAuth(e.data));
    },
    onError: e => {
      navigate(ROUTE_PATHS.SIGN_IN);
      showToast.error(toastMessages.EXPIRED_INCORRECT_LINK);
    },
  });

  return <h1>{REDIRECTING}</h1>;
};

export default InvitationToken;
